import { render, staticRenderFns } from "./ProductionTimeTable.vue?vue&type=template&id=c2e4dffc&scoped=true&"
import script from "./ProductionTimeTable.vue?vue&type=script&lang=ts&"
export * from "./ProductionTimeTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProductionTimeTable.vue?vue&type=style&index=0&id=c2e4dffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e4dffc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAlert,VChip})
